import React from 'react';
import {Form, Message, Header} from 'semantic-ui-react';
import {withFormik} from 'formik';
import Yup from 'yup';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {
  InlineSelect,
  TextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import _ from 'lodash';
import {selectableRoles, createRolePermissionsBox} from './utils';
import {checkIfEmailIsFEMA, checkIfEmailIsValid} from 'common/utils';
import {email_regex} from 'go/components/organization/team/constants';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';

export const InnerForm = ({
  values,
  errors = {},
  isSubmitting,
  handleBlur,
  handleSubmit,
  handleChange,
  touched,
  setFieldValue,
  addModalVisible,
  toggleModal,
  loading,
  status,
  entityId,
  entity_opts,
  role_opts,
  setErrors,
  setStatus,
  roles,
  toggles,
  action,
}) => {
  if (_.size(entity_opts) > 0 && _.isEqual(_.get(values, 'entity'), '')) {
    handleChange(null, {name: 'entity', value: entity_opts[0].value});
  }

  if (!_.isEqual(_.get(values, 'entityTypeId'), entityId)) {
    handleChange(null, {name: 'entityTypeId', value: entityId});
  }
  const temp = _.get(values, 'entity');
  const roleOption = _.concat(
    [{key: 0, value: ''}],
    _.get(role_opts, _.get(values, 'entity'), [])
  );
  const getLabel = () => {
    if (entityId === ENTITY_MAP.REPORT_CATEGORY.code) {
      return 'Report Category';
    } else {
      return entityId === ENTITY_MAP.ORGANIZATION.code ? 'Org' : 'Program';
    }
  };

  return (
    <FemaGoModal
      title="Add a new team member"
      open={addModalVisible}
      size="large"
      buttonText="Add Team Member"
      disableButton={
        !checkIfEmailIsFEMA(values.email) ||
        !values.email ||
        !checkIfEmailIsValid(values.email) ||
        !values.role
      }
      confirmAction={(e) => handleSubmit(e)}
      cancelAction={() => {
        setErrors({});
        setStatus(null);
        toggleModal('add');
      }}
    >
      {status && <Message negative>{status.errorMsg}</Message>}
      {!loading ? (
        <Form onSubmit={handleSubmit}>
          <Header as="h4">Search for your colleague</Header>
          <TextBoxField
            size="small"
            label="Email"
            name="email"
            title="email"
            handleChange={handleChange}
            handleBlur={handleBlur}
            values={values.email}
            errorMessages={errors.email}
            displayError={touched.email && errors.email}
          />
          <Header as="h4">What roles do you want to give your colleagues?</Header>
          <Form.Group>
            <InlineSelect
              label={getLabel()}
              name="entity"
              options={entity_opts}
              value={values.entity}
              handleChange={(e) => {
                const data = e.target;
                if (data && data.name) {
                  if (data.value !== values.entity) {
                    setFieldValue('role', '');
                  }
                  setFieldValue('entity', data.value);
                }
              }}
              errorMessages={errors.entity}
              displayError={touched.entity && errors.entity}
            />
            <InlineSelect
              label="Role"
              name="role"
              options={roleOption}
              value={values.role}
              handleChange={(e) => {
                const data = e.target;
                if (data && data.name) {
                  setFieldValue('role', data.value);
                }
              }}
              errorMessages={errors.role}
              displayError={touched.role && errors.role}
            />
          </Form.Group>
          {createRolePermissionsBox(selectableRoles(roles), toggles)}
        </Form>
      ) : (
        <div>Loading entities</div>
      )}
    </FemaGoModal>
  );
};

export const withSemanticUIFormik = (props, values) => (WrappedComponent) => {
  return withFormik(
    props,
    values
  )(
    class extends React.Component {
      handleChange = (e, data) => {
        if (data && data.name) {
          this.props.setFieldValue(data.name, data.value);
        }
      };

      render() {
        return (
          <WrappedComponent
            {...this.props}
            // handleBlur={this.handleBlur}
            handleChange={this.handleChange}
            setFieldValue={this.props.setFieldValue}
            addModalVisible={this.props.addModalVisible}
            createOrgUser={this.props.createUser}
            loading={this.props.loading}
          />
        );
      }
    }
  );
};

export const AddOrgUserForm = withSemanticUIFormik({
  mapPropsToValues: (props) => {
    return {
      email: '',
      entity: '',
      role: '',
      entityTypeId: '',
    };
  },
  validationSchema: (props) =>
    Yup.object().shape({
      email: Yup.mixed()
        .required('Please enter a valid email')
        .test('is-valid-email', 'Please enter a valid email', (value) => {
          return email_regex.test(value);
        })
        .test('is-fema-email', 'Please enter a valid FEMA email', (value) => {
          if (
            (props.entityId === ENTITY_MAP.PROGRAM.code ||
              props.entityId === ENTITY_MAP.REPORT_CATEGORY.code) &&
            value !== undefined
          ) {
            return checkIfEmailIsFEMA(value);
          }
          return true;
        }),
      entity: Yup.string().required('Please select an option'),
      role: Yup.string().required('Please select an option'),
    }),

  handleSubmit: async (values, {props, setStatus, setSubmitting}) => {
    setSubmitting(true);
    try {
      const res = await props.createUser(values);
      if (res.ok) {
        setSubmitting(false);
        props.toggleModal('add');
        let resLoad = await props.reloadUserList();
      } else {
        let body = await res.json();
        if (body.error) {
          setStatus({
            errorMsg: body.error,
          });
        } else {
          setStatus({
            errorMsg:
              'An error occurred while processing your request - please try again.',
          });
        }
        setSubmitting(false);
      }
    } catch (e) {
      setStatus({
        errorMsg: 'An error occurred while processing your request - please try again.',
      });
      setSubmitting(false);
    }
  },
})(InnerForm);

export default AddOrgUserForm;
